export const COMPANY_NAME = "VendiDirect.it srls";
export const COMPANY_ADDRESS = "via Carlo Alberto Radaelli 11/13, Segrate (MI)";
export const COMPANY_VAT = "14883250962";
export const COMPANY_PEC = "vendidirect.itsrls@lamiapec.it";
export const SUPPORT_EMAIL = "supporto.vendidirect@gmail.com";